export const AVATAR_TONES = {
  bay: "#6B4A33",
  chestnut: "#A55A2B",
  grey: "#7B8590",
  black: "#2A2D34",
  palomino: "#B5894A",
  piebald: "#3C3F46",
  dun: "#9C8054",
  roan: "#8E6D6D",
} as const;

export type HorseColour = keyof typeof AVATAR_TONES;
export const DEFAULT_TONE = AVATAR_TONES.bay;
